import { render, staticRenderFns } from "./Components.vue?vue&type=template&id=3da0bb74&lang=pug&"
import script from "./Components.vue?vue&type=script&lang=ts&"
export * from "./Components.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports